export default __webpack_public_path__ + "static/media/wwd-block-1.5b2f395c.jpg";